import FormattedMessage from 'I18n/components/FormattedMessage';
import CopyConversationLink from '../links/CopyConversationLink';
import CreateTicketLink from '../links/CreateTicketLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function TicketNotFoundView() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.panel.body.errors.notFound"
    }), /*#__PURE__*/_jsx("div", {
      className: "m-top-2",
      children: /*#__PURE__*/_jsx(CopyConversationLink, {})
    }), /*#__PURE__*/_jsx("div", {
      className: "m-top-2",
      children: /*#__PURE__*/_jsx(CreateTicketLink, {})
    })]
  });
}
export default TicketNotFoundView;